(function () {
  const shopRoot = () => (
    window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/'
  );

  const bounceCartCount = (count) => {
    document.querySelectorAll('[data-cart-count]').forEach((counter) => {
      counter.textContent = count;
      counter.classList.add('bounce');
      setTimeout(() => counter.classList.remove('bounce'), 300);
    });
  };

  const refreshCartCount = async () => {
    const response = await fetch(`${shopRoot()}cart.js`, {
      headers: { Accept: 'application/json' }
    });

    if (!response.ok) return;

    const cart = await response.json();
    bounceCartCount(cart.item_count);
  };

  const setButtonState = (button, state) => {
    if (!button) return;

    if (state === 'loading') {
      button.disabled = true;
      button.textContent = button.dataset.loadingLabel || button.dataset.addLabel || button.textContent;
      return;
    }

    if (state === 'added') {
      button.disabled = false;
      button.textContent = button.dataset.addedLabel || button.dataset.addLabel || button.textContent;
      setTimeout(() => {
        button.textContent = button.dataset.addLabel || button.textContent;
      }, 1400);
      return;
    }

    if (state === 'error') {
      button.disabled = false;
      button.textContent = button.dataset.errorLabel || button.dataset.addLabel || button.textContent;
      setTimeout(() => {
        button.textContent = button.dataset.addLabel || button.textContent;
      }, 1800);
      return;
    }

    button.disabled = false;
    button.textContent = button.dataset.addLabel || button.textContent;
  };

  document.querySelectorAll('[data-card-size]').forEach((sizeButton) => {
    sizeButton.addEventListener('click', () => {
      if (sizeButton.disabled) return;

      const card = sizeButton.closest('.product-card');
      if (!card) return;

      card.querySelectorAll('[data-card-size]').forEach((button) => {
        button.classList.toggle('active', button === sizeButton);
      });

      const price = card.querySelector('[data-card-price]');
      if (price && sizeButton.dataset.price) {
        price.textContent = sizeButton.dataset.price;
      }

      const unitPrice = card.querySelector('[data-card-unit-price]');
      if (unitPrice && sizeButton.dataset.unitPrice) {
        unitPrice.textContent = sizeButton.dataset.unitPrice;
      }

      const comparePrice = card.querySelector('[data-card-compare-price]');
      if (comparePrice) {
        if (sizeButton.dataset.comparePrice) {
          comparePrice.textContent = sizeButton.dataset.comparePrice;
          comparePrice.hidden = false;
        } else {
          comparePrice.textContent = '';
          comparePrice.hidden = true;
        }
      }

      const addButton = card.querySelector('[data-add-selected-variant]');
      if (addButton) {
        addButton.disabled = !sizeButton.dataset.variantId || sizeButton.disabled;
      }
    });
  });

  document.querySelectorAll('[data-scroll-target]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.getElementById(link.dataset.scrollTarget);
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth' });
    });
  });

  document.querySelectorAll('[data-add-selected-variant]').forEach((button) => {
    button.addEventListener('click', async () => {
      const scope = button.closest('.product-card');
      const activeVariant = scope && scope.querySelector('[data-card-size].active');
      const variantId = (activeVariant && activeVariant.dataset.variantId) || button.dataset.variantId;

      if (!variantId) {
        setButtonState(button, 'error');
        return;
      }

      setButtonState(button, 'loading');

      try {
        const response = await fetch(`${shopRoot()}cart/add.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            id: Number(variantId),
            quantity: 1
          })
        });

        if (!response.ok) throw new Error('Add to cart failed');

        await refreshCartCount();
        setButtonState(button, 'added');
      } catch (error) {
        setButtonState(button, 'error');
      }
    });
  });

  const productImage = document.querySelector('[data-product-main-image]');
  const productVariantSelect = document.querySelector('.product-form select[name="id"]');

  if (productImage && productVariantSelect) {
    productVariantSelect.addEventListener('change', () => {
      const selectedOption = productVariantSelect.selectedOptions[0];

      if (!selectedOption || !selectedOption.dataset.productImageSrc) return;

      productImage.src = selectedOption.dataset.productImageSrc;
      productImage.alt = selectedOption.dataset.productImageAlt || '';
    });
  }

  const cartSummary = document.querySelector('[data-cart-summary]');

  if (cartSummary) {
    const discountInput = cartSummary.querySelector('[data-cart-discount-input]');
    const discountButton = cartSummary.querySelector('[data-cart-discount-button]');
    const discountStatus = cartSummary.querySelector('[data-cart-discount-status]');
    const subtotalEl = cartSummary.querySelector('[data-cart-subtotal]');
    const totalEl = cartSummary.querySelector('[data-cart-total]');
    const discountsEl = cartSummary.querySelector('[data-cart-discounts]');
    const originalButtonLabel = discountButton ? discountButton.textContent : '';

    const formatWithDelimiters = (number, precision = 2, thousands = ',', decimal = '.') => {
      if (Number.isNaN(number) || number == null) return '0';

      const fixed = (number / 100).toFixed(precision);
      const parts = fixed.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
      const cents = parts[1] ? decimal + parts[1] : '';

      return dollars + cents;
    };

    const formatMoney = (cents) => {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, cartSummary.dataset.moneyFormat);
      }

      const format = cartSummary.dataset.moneyFormat || '${{amount}}';
      const placeholder = format.match(/\{\{\s*(\w+)\s*\}\}/);

      if (!placeholder) return format;

      const token = placeholder[1];
      let value;

      switch (token) {
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }

      return format.replace(placeholder[0], value);
    };

    const escapeHtml = (value) => String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');

    const updateCartTotals = (cart) => {
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.items_subtotal_price);
      if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

      document.querySelectorAll('[data-cart-line-total]').forEach((lineTotal, index) => {
        if (!cart.items[index]) return;
        lineTotal.textContent = formatMoney(cart.items[index].final_line_price);
      });

      if (!discountsEl) return;

      const applications = cart.cart_level_discount_applications || [];
      const totalDiscount = cart.total_discount || 0;

      const discountRows = applications.map((discount) => ({
        title: discount.title || discount.code || cartSummary.dataset.discountLabel || 'Discount code',
        amount: discount.total_allocated_amount || discount.amount || 0
      })).filter((discount) => discount.amount > 0);

      if (discountRows.length > 0) {
        discountsEl.innerHTML = discountRows.map((discount) => `
          <div class="cart-discount-row">
            <span>${escapeHtml(discount.title)}</span>
            <strong>-${formatMoney(discount.amount)}</strong>
          </div>
        `).join('');
        discountsEl.hidden = false;
      } else if (totalDiscount > 0) {
        discountsEl.innerHTML = `
          <div class="cart-discount-row">
            <span>${escapeHtml(cartSummary.dataset.discountLabel || 'Discount code')}</span>
            <strong>-${formatMoney(totalDiscount)}</strong>
          </div>
        `;
        discountsEl.hidden = false;
      } else {
        discountsEl.innerHTML = '';
        discountsEl.hidden = true;
      }
    };

    const setDiscountStatus = (message) => {
      if (discountStatus) discountStatus.textContent = message;
    };

    const applyDiscountCode = async () => {
      if (!discountInput || !discountButton) return;

      const code = discountInput.value.trim();

      if (!code) {
        setDiscountStatus(cartSummary.dataset.discountRequired || 'Enter a discount code first.');
        discountInput.focus();
        return;
      }

      discountButton.disabled = true;
      discountButton.textContent = cartSummary.dataset.discountLoading || 'Applying code...';

      try {
        const response = await fetch(`${shopRoot()}cart/update.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ discount: code })
        });

        if (!response.ok) throw new Error('Discount request failed');

        const cart = await response.json();
        const discountCodes = cart.discount_codes || [];
        const matchingCode = discountCodes.find((discount) => (
          discount.code && discount.code.toLowerCase() === code.toLowerCase()
        ));

        updateCartTotals(cart);
        bounceCartCount(cart.item_count);

        if (matchingCode && matchingCode.applicable === false) {
          setDiscountStatus(cartSummary.dataset.discountInvalid || 'This discount code is not valid for the items in your cart.');
        } else if (matchingCode || discountCodes.length > 0 || cart.total_discount > 0) {
          setDiscountStatus(cartSummary.dataset.discountApplied || 'Discount code applied.');
        } else {
          setDiscountStatus(cartSummary.dataset.discountInvalid || 'This discount code is not valid for the items in your cart.');
        }
      } catch (error) {
        setDiscountStatus(cartSummary.dataset.discountError || 'The discount code could not be applied. Please try again.');
      } finally {
        discountButton.disabled = false;
        discountButton.textContent = originalButtonLabel;
      }
    };

    if (discountButton) {
      discountButton.addEventListener('click', applyDiscountCode);
    }

    if (discountInput) {
      discountInput.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter') return;
        event.preventDefault();
        applyDiscountCode();
      });
    }
  }

  document.querySelectorAll('[data-copy-link]').forEach((copyBtn) => {
    if (!navigator.clipboard) return;

    const originalLabel = copyBtn.textContent;
    const successLabel = copyBtn.dataset.copySuccess || 'Link copied';

    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(window.location.href);
        copyBtn.textContent = successLabel;
        setTimeout(() => {
          copyBtn.textContent = originalLabel;
        }, 1500);
      } catch (error) {
      }
    });
  });

  const mobileMenu = document.querySelector('[data-mobile-menu]');
  const menuOpenBtn = document.querySelector('[data-menu-open]');

  if (mobileMenu && menuOpenBtn) {
    const menuCloseBtn = mobileMenu.querySelector('[data-menu-close]');

    const setMenuOpen = (open) => {
      mobileMenu.hidden = !open;
      menuOpenBtn.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      if (open && menuCloseBtn) menuCloseBtn.focus();
      if (!open) menuOpenBtn.focus();
    };

    menuOpenBtn.addEventListener('click', () => setMenuOpen(true));
    if (menuCloseBtn) menuCloseBtn.addEventListener('click', () => setMenuOpen(false));

    mobileMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => setMenuOpen(false));
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mobileMenu.hidden) setMenuOpen(false);
    });

    window.matchMedia('(min-width: 980px)').addEventListener('change', (event) => {
      if (event.matches && !mobileMenu.hidden) setMenuOpen(false);
    });
  }
})();

(() => {
  const cards = document.querySelectorAll('.tiktok-card');
  if (!cards.length) return;

  const saveData = navigator.connection && navigator.connection.saveData;
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const autoplay = !saveData && !reduceMotion;

  const load = (video) => {
    if (!video.src) video.src = video.dataset.src;
  };

  const play = (card) => {
    const video = card.querySelector('video');
    load(video);
    const started = video.play();
    if (started) started.then(() => card.classList.add('is-playing')).catch(() => {});
  };

  const pause = (card) => {
    card.querySelector('video').pause();
    card.classList.remove('is-playing');
  };

  const setSound = (card, on) => {
    card.querySelector('video').muted = !on;
    card.classList.toggle('is-unmuted', on);
    card.setAttribute('aria-pressed', String(on));
  };

  if (autoplay && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          play(entry.target);
        } else {
          pause(entry.target);
          setSound(entry.target, false);
        }
      });
    }, { threshold: 0.6 });
    cards.forEach((card) => observer.observe(card));
  }

  cards.forEach((card) => {
    card.addEventListener('click', () => {
      const unmute = !card.classList.contains('is-unmuted');
      cards.forEach((other) => setSound(other, false));
      if (unmute) {
        setSound(card, true);
        play(card);
      }
    });
  });
})();

(() => {
  const fill = document.querySelector('.goal-bar-fill');
  if (!fill || !('IntersectionObserver' in window)) return;

  const target = fill.style.width;
  fill.style.width = '0%';
  const observer = new IntersectionObserver((entries) => {
    if (!entries.some((entry) => entry.isIntersecting)) return;
    fill.style.width = target;
    observer.disconnect();
  }, { threshold: 0.5 });
  observer.observe(fill.parentElement);
})();

(() => {
  const container = document.querySelector('.carousel-container');
  if (!container) return;

  document.querySelectorAll('[data-carousel-step]').forEach((button) => {
    button.addEventListener('click', () => {
      const card = container.querySelector('.product-card');
      const step = card ? card.offsetWidth + 16 : container.clientWidth * 0.8;
      container.scrollBy({ left: Number(button.dataset.carouselStep) * step, behavior: 'smooth' });
    });
  });
})();
